import { Button, Stack, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useManageModal } from "src/hooks/useManageModal";
import { useMemo } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import WhiteCard from "src/components/WhiteCard";
import { useGetProviderSpecialtiesQuery } from "src/api/services/providersApi";
import Specialty from "../Specialty";
import CreateProviderSpecialtiesModal from "src/components/Modals/CreateProviderSpecialtiesModal";

interface Props {
  providerId: number;
}
const Specialties = ({ providerId }: Props) => {
  const { data: providerSpecialties = [] } = useGetProviderSpecialtiesQuery(
    providerId ?? skipToken
  );

  const [open, { handleClose, handleOpen }] = useManageModal();

  const specialties = useMemo(
    () => providerSpecialties.map((s) => s.specialty),
    [providerSpecialties]
  );

  const key = useMemo(() => {
    return specialties.join(",");
  }, [specialties]);

  return (
    <>
      <WhiteCard gap={1} sx={{ overflowY: "auto" }}>
        <Stack gap={1}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle2">PROVIDER SPECIALTIES</Typography>
            <Button
              variant="text"
              sx={{ alignSelf: "start" }}
              onClick={handleOpen}
              startIcon={<AddIcon />}
            >
              Create
            </Button>
          </Stack>

          <Stack>
            {providerSpecialties.map((s) => (
              <Specialty providerSpecialty={s} key={s.specialty} />
            ))}
          </Stack>
        </Stack>
      </WhiteCard>
      <CreateProviderSpecialtiesModal
        key={key}
        open={open}
        onClose={handleClose}
        providerId={providerId}
        providerSpecialties={specialties}
      />
    </>
  );
};

export default Specialties;
